<template>
  <v-dialog v-model="dialog" persistent width="700">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>edit</v-icon> Modificar fecha de reprogramación
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close(false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- Cuerpo del formulario -->
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text class="py-0 px-3">
          <v-container grid-list-md style="min-width: 100%;" class="p-0">
            <b class="blue--text"
              >Ingrese la nueva fecha de su reprogramación:
            </b>
            <v-layout wrap>
              <v-flex md4>
                <v-text-field
                  @change="calculaDiferenciaDias()"
                  type="date"
                  v-model="form.fecha_desde"
                  label="Fecha inicio"
                  :rules="$validate(['required'])"
                  required
                  outline
                  success
                  clearable
                />
              </v-flex>
              <v-flex md4>
                <v-text-field
                  @change="calculaDiferenciaDias()"
                  type="date"
                  v-model="form.fecha_hasta"
                  label="Fecha fin"
                  :rules="$validate(['required'])"
                  required
                  outline
                  success
                  clearable
                />
              </v-flex>
              <v-flex md4>
                <v-text-field
                  v-if="form.fecha_desde && form.fecha_hasta"
                  v-model="form.total_dias"
                  label="Días"
                  disabled
                  outline
                  success
                  clearable
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="close(false)">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="rgba(14, 187, 178, 0.35)"
            :loading="loading"
            @click="save()"
            :disabled="
              !form.fecha_desde || !form.fecha_desde || !form.total_dias
            "
          >
            <v-icon dark>check</v-icon>GUARDAR
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  components: {},
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      copia_reprogramacion: null
    };
  },
  async mounted() {
    this.$bus.$on("openDialogEditaFechasReprogramacion", async item => {
      this.form = item;
      this.copia_reprogramacion = JSON.parse(JSON.stringify(item));
      this.form.fecha_desde = this.$moment(
        this.form.fecha_desde,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD");
      this.form.fecha_hasta = this.$moment(
        this.form.fecha_hasta,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD");
      this.dialog = true;
    });
  },
  methods: {
    //calcula la diferencia de días entre dos fechas:
    async calculaDiferenciaDias() {
      try {
        if (!this.form.fecha_desde || !this.form.fecha_hasta) {
          this.$message.info("Ingrese correctamente las fechas");
          return false;
        }
        let res;
        let year1 = new Date(this.form.fecha_desde).getFullYear();
        let year2 = new Date(this.form.fecha_hasta).getFullYear();
        let gestion_original = this.$moment(
          this.form.fecha_desde_padre,
          "DD/MM/YYYY"
        ).year();

        if (year1 != gestion_original || year2 != gestion_original) {
          this.$message.warning("Solo puede reprogramar en la misma gestión");
          return false;
        }
        if (this.form.fecha_desde && this.form.fecha_hasta) {
          let user = this.$storage.get("user");
          res = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select general.fn_cuenta_dias_habiles_por_persona('${this.form.fecha_desde}','${this.form.fecha_hasta}',${this.form.id_persona})"){
                  respuesta
                }
              }
            `
          });
          let res2 =
            res.runQuery.respuesta[0].fn_cuenta_dias_habiles_por_persona;
          this.form.total_dias = res2;
          return true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    close(sw_guardar) {
      if (!sw_guardar) {
        // Guardamos los valores anteriores de la reprogramacion
        this.form.fecha_desde = this.copia_reprogramacion.fecha_desde;
        this.form.fecha_hasta = this.copia_reprogramacion.fecha_hasta;
        this.form.total_dias = this.copia_reprogramacion.total_dias;
      }
      this.form = {};
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogEditaFechasReprogramacion");
      this.dialog = false;
    },
    async save() {
      try {
        let sw_valido = await this.calculaDiferenciaDias();
        if (!sw_valido) {
        }
        // Validamos que no supero el nro total de dias a reprogramar
        if (
          this.form.total_dias_reprogramar <
          this.form.dias_programados + this.form.total_dias
        ) {
          this.$message.info("No puede superar el nro de dias a reprogramar");
          return;
        }
        this.form.fecha_desde = this.$moment(this.form.fecha_desde).format(
          "DD/MM/YYYY"
        );
        this.form.fecha_hasta = this.$moment(this.form.fecha_hasta).format(
          "DD/MM/YYYY"
        );
        this.close(true);
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/dialogs/EditaFechasReprogramacion.vue